import React, { useState } from "react";
import {
  Star as StarIcon,
  TrendingDown as TrendingDownIcon,
  CreditCard as CreditCardIcon,
  Balance as BalanceIcon,
} from "@mui/icons-material";

const ResolveDebt = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const benefits = [
    {
      icon: <StarIcon className="!text-6xl" />,
      title: "Compare our advantages and savings over out of state companies",
      description:
        "Our Texas Debt Relief service is performance-based, and our fees are up to 40% LESS compared to many out-of-state competitors.",
    },
    {
      icon: <TrendingDownIcon className="!text-6xl" />,
      title: "Options for interest reductions or negotiated balance reductions",
      description:
        "Negotiated balance reductions and resources to other options:  Our Texas Debt Relief program helps Texans by negotiating reductions of credit card and personal loan debt balances. This program may resolve debt in as little as 12 to 60 months, with program payments often less than half compared to minimum payments. We can also recommend options to reduce interest rates without a new loan.",
    },
    {
      icon: <CreditCardIcon className="!text-6xl" />,
      title: "Shop Credit Card Debt Consolidation Loans up to 100K",
      description:
        "We also provide an affiliate platform to help shop for debt consolidation loans up to 100K to pay off high credit card debt.  Review offers from multiple lenders who offer debt consolidation loans to Texans without a fee or any impact on your credit score.",
    },
    {
      icon: <BalanceIcon className="!text-6xl" />,
      title: (
        <>
          Facing a creditor lawsuit? <br /> Contact us right away for affordable
          assistance
        </>
      ),
      description:
        "Through a special arrangement with whom we feel is the strongest debt defense attorney in Texas, we can help Texans state-wide who have received a court summons from a creditor.  However, time is not on your side, so call today to discuss your options.",
    },
  ];

  return (
    <div className="py-16">
      <div className="container mx-auto text-center px-4 sm:px-8">
        <h2 className="text-2xl sm:text-4xl text-black mb-12">
          Resolve Credit Card Debt and Personal Loans in as Little as
          <br />
          <strong className="text-sky-700">12 to 60 Months</strong>
        </h2>
        <div className="grid grid-cols-1 gap-3 lg:grid-cols-4">
          {benefits.map(({ icon, title }, index) => (
            <div className="lg:flex h-full" key={index}>
              <div
                className={`flex flex-col items-center justify-center py-6 px-8 cursor-pointer w-full ${
                  selectedIndex === index
                    ? "bg-sky-800 border-0"
                    : `bg-transparent lg:border border-gray-500 mb-3`
                }`}
                onClick={() =>
                  selectedIndex !== index ? setSelectedIndex(index) : undefined
                }
                role="none"
                key={index}
              >
                <div
                  className={`text-sky-700 ${
                    selectedIndex === index
                      ? "bg-white p-4 my-6 rounded-full"
                      : "mb-3"
                  }`}
                >
                  {icon}
                </div>
                {selectedIndex === index ? null : (
                  <p className="text-lg text-black">{title}</p>
                )}
              </div>
              {selectedIndex === index && (
                <p className="bg-sky-700 py-6 px-12 text-white text-lg mb-3 font-semibold lg:hidden">
                  {benefits[selectedIndex].description}
                </p>
              )}
            </div>
          ))}
        </div>
        <div className="bg-sky-700 py-6 px-12 text-white text-lg font-semibold max-lg:hidden">
          {benefits[selectedIndex].description}
        </div>
      </div>
    </div>
  );
};

export default ResolveDebt;
